var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navi"},_vm._l((_vm.items),function(i){return _c('div',{staticClass:"item",on:{"click":function($event){return _vm.goto(i.target)}}},[_c('icon',{staticClass:"small",attrs:{"name":"next"}}),_c('span',[_vm._v(_vm._s(i.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }